var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-body-2 ma-2"},[_c('tag',{staticClass:"mr-2",attrs:{"bg-color":_vm.listingTaskStatusColor(_vm.subtask.status),"color":"white"}},[_vm._v(_vm._s(_vm.subtask.status)+" ")]),_vm._v(" "+_vm._s(_vm.subtask.description)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }